import React from 'react';
import { ReactComponent as SalaryPayTypeIcon } from '../../../assets/image-icon/SVG_tag.svg';
import { ReactComponent as SalaryEstimateIcon } from '../../../assets/image-icon/SVG_read.svg';
import { ReactComponent as JobCategoryIcon } from '../../../assets/image-icon/SVG_write.svg';
import { ReactComponent as StateJobIcon } from '../../../assets/image-icon/SVG_locate.svg';
import { ReactComponent as ThinkIcon } from '../../../assets/image-icon/SVG_think.svg';
import RenderSvgIcon from '../../../components/RenderSvgIcon';

const wrapStyleIcon1 = {
  width: 17,
  height: 17,
  fill: 'currentColor',
  alignSelf: 'center',
  transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
};

function Index({ item }) {

  return (
    <React.Fragment>
      {item === 'item_a' && <RenderSvgIcon name={'SVG_write'} style={wrapStyleIcon1} />}
      {item === 'item_b' && <RenderSvgIcon name={'SVG_tag'} style={wrapStyleIcon1} />}
      {item === 'item_c' && <RenderSvgIcon name={'SVG_read'} style={wrapStyleIcon1} />}
      {item === 'item_d' && <RenderSvgIcon name={'SVG_locate'} style={wrapStyleIcon1} />}
      {item === 'item_e' && <RenderSvgIcon name={'SVG_think'} style={wrapStyleIcon1} />}
    </React.Fragment>
  );
}

export default Index;
